"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7 0L5 5 0 6.998 5 9l2 5 2-5 5-1.995L9 5zM15 10l-1.5 3.496-3.5 1.499 3.5 1.498L15 20l1.5-3.507L20 15l-3.5-1.504z"];
//# sourceMappingURL=clean.js.map